import { api } from "@/lib/api";

export type SupportRequest = {
  nome: string;
  data: string;
  area: string;
  novaFeature: string;
  cenario: string;
  processoAtual: string;
  ferramentas: string;
};

export const supportApi = {
  /** Envia o formulário de suporte (o backend repassa pra planilha). */
  submit: (payload: SupportRequest) =>
    api.post<{ ok: boolean; forwarded?: boolean }>("/support-request", payload),
};
